import React from "react";
import { Link } from 'gatsby'
import * as classes from './ButtonLink.module.css'

const ButtonLink = ({to, children}) => {
    return <Link className={classes.buttonLink} to={to}>{children}</Link>
}

export default ButtonLink